import { atom } from 'jotai';

export const isPreviewFormSubmittedAtom = atom(false);
